import { Pipe, PipeTransform, inject } from '@angular/core';
import { LangFacade } from '@library/store/lang/lang.facade';
import { take } from 'rxjs/operators';

@Pipe({
  name: 'LANG',
  standalone: false,
})
export class LangPipe implements PipeTransform {
  private readonly langFacade = inject(LangFacade);

  transform(value, args: string[] = []): string {
    let trans = '';

    this.langFacade
      .translate(value, args)
      .pipe(take(1))
      .subscribe((t) => (trans = t));

    return trans;
  }
}
